<template>
  <ItemContainer :title="title">
    <data-table
      cell-class-name="truncate-table-cell-wrap"
      align="center"
      :data="settleChartData"
      @sort-change="sortChange()"
      :columns="tableCol"
      :loading="tableLoading"
      :showPage="false"
    >
      <template #operationalYuanAmount="{ row }">
        <div :id="row.operationalYuanAmount + 'echarts'" style="width: 150px; height: 20px"></div>
      </template>
      <template #action>
        <el-button type="text" @click="$router.push({ name: 'project-detail' })">查看</el-button>
      </template>
    </data-table>
  </ItemContainer>
</template>

<script>
import echarts from '@/plugins/echarts.js'
import DataTable from '@/components/base/DataTable'
import ItemContainer from '@/components/base/ItemContainer.vue'
export default {
  components: {
    ItemContainer,
    DataTable
  },
  props: {
    title: {
      type: String,
      default: ' '
    },
    tableCol: {
      type: Array,
      default: []
    },
    settleChartData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableLoading: false,
      maxNum: 0
    }
  },
  mounted() {
    this.getMaxNum()
    // this.showCharts()
  },
  created() {},
  methods: {
    // 排序重新渲染柱状图
    sortChange() {
      this.getMaxNum()
      // this.showCharts()
    },
    getMaxNum() {
      this.settleChartData.forEach(item => {
        if (item.operationalYuanAmount > this.maxNum) {
          this.maxNum = item.operationalYuanAmount
          this.maxNum = this.maxNum * 1.2
        }
      })
    },
    // 柱状图显示
    showCharts() {
      // setTimeout(() => {
      //   this.settleChartData.forEach(item => {
      //     var chartEle = document.getElementById(item.operationalYuanAmount + 'echarts')
      //     var myChart = echarts.init(chartEle)
      //     myChart.setOption({
      //       tooltip: {
      //         show: false
      //       },
      //       xAxis: {
      //         show: false,
      //         max: this.maxNum //这里限制坐标轴的最大值为(numMax*1.2)
      //       },
      //       yAxis: {
      //         show: false,
      //         axisLabel: {
      //           show: false
      //         },
      //         data: ['operationalYuanAmount']
      //       },
      //       series: [
      //         {
      //           name: 'operationalYuanAmount',
      //           type: 'bar',
      //           data: [item.operationalYuanAmount],
      //           label: {
      //             show: true,
      //             position: 'right',
      //             color: '#333',
      //             fontSize: '12px'
      //           },
      //           // barWidth: '20%',
      //           itemStyle: {
      //             color: 'grey'
      //           }
      //         }
      //       ]
      //     })
      //     window.addEventListener('resize', () => {
      //       myChart.resize()
      //     })
      //   })
      // }, 500)
    }
  },
  beforeDestroy() {}
}
</script>

<style></style>
